import React from 'react';
import { Flex } from 'antd';
import { useFormik } from 'formik';

import { PromocodeForm } from '../components/PromocodeForm';
import { usePromocodeForm } from '../hooks/usePromocodeForm';
import { getValidationSchema, initialValues } from '../utils/fields';
import { PromocodeFormTypeSwitcher } from '../components/PromocodeFormTypeSwitcher';
import { Save } from '../../../widgets/Save';
import { PAGE_TYPE } from '../service/promocodes.interface';
import { useAppSelector } from '../../../../../store';
import { selectPromocode } from '../store/promocode.slice';

export const PromocodeCreate = () => {
    const { onSubmit, isLoading } = usePromocodeForm({
        type: PAGE_TYPE.CREATE,
    });

    const { formType } = useAppSelector(selectPromocode);

    const formik = useFormik({
        initialValues,
        validationSchema: getValidationSchema(formType),
        onSubmit: onSubmit,
        validateOnChange: false,
        validateOnBlur: true,
        validateOnMount: false,
        enableReinitialize: true,
    });

    return (
        <Flex vertical gap={24}>
            <PromocodeFormTypeSwitcher
                onChangeType={() => {
                    formik.resetForm({ values: initialValues });
                }}
            />
            <PromocodeForm formik={formik} />
            <Save
                onSave={() => {
                    void onSubmit(formik.values);
                }}
                disabled={isLoading || !formik.isValid}
                loading={isLoading}
            />
        </Flex>
    );
};
